import React from 'react';
import { siteContent } from '../data/mock';

const HowItWorks = () => {
  const { howItWorks } = siteContent;

  return (
    <section className="py-24 bg-neutral-50">
      <div className="mx-auto max-w-6xl px-6">
        <h2 className="text-3xl md:text-4xl font-medium text-neutral-900 mb-16">
          {howItWorks.title}
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {howItWorks.columns.map((column) => (
            <div key={column.title}>
              <h3 className="text-xl font-medium text-neutral-900 mb-6">
                {column.title}
              </h3>
              <ul className="space-y-3">
                {column.points.map((point) => (
                  <li key={point} className="text-base text-neutral-600 leading-relaxed">
                    {point}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
